<mat-form-field
  [id]="id()"
  appearance="outline"
  [subscriptSizing]="showBottomMargin() ? 'fixed' : 'dynamic'"
  floatLabel="always"
  [class]="'sia-input sia-small-width ' + inputClass()"
>
  <mat-label
    >{{ label() | siaTranslate }}
    @if (info()) {
      <span
        [siaTooltip]="info() ?? ''"
        position="right"
        class="sia-info"
        [innerHTML]="infoIcon()"
      >
      </span>
    }
  </mat-label>
  <input
    [siaTooltip]="fieldErrors()"
    [disable]="!visibleTooltip()"
    matTooltipClass="sia-tooltip"
    type="tel"
    matInput
    [(ngModel)]="value"
    [disabled]="isDisabled()"
    [id]="id() ?? ''"
    [tabindex]="tabDisabled() ? '-1' : '0'"
  />
  @if (showBottomMargin()) {
    <mat-hint
      sia-error-hint
      [statusMessage]="statusMessage()"
      [statusMessages]="statusMessages()"
    ></mat-hint>
  }
</mat-form-field>
<div class="flex h-full items-center">
  <sia-phone-button [isMobile]="isMobile()" [telephone]="value()">
  </sia-phone-button>
</div>
